
import live_streaming from '../assets/live_streaming.png'
import { AiOutlineShoppingCart, AiOutlineHistory, AiOutlineUser, AiOutlineDollarCircle, AiOutlineGift } from "react-icons/ai";
import { BiStore } from "react-icons/bi";
import ReactLogo from '../assets/voucher.svg';
import { TiTicket } from "react-icons/ti";
import { MdListAlt } from "react-icons/md";
export const navs = [
    {
        id: 1,
        title: "Belanja",
link: "/product",
        type: 'image',
        icon: <AiOutlineShoppingCart/>
    },
    // {
    //     id: 2,
    //     title: "Riwayat",
    //     link: "/history",
    //     type: 'image',
    //     icon: <AiOutlineHistory/>
    // },
    {
        id: 3,
        title: "Penukaran",
        link: "/redeem",
        type: 'image',
        icon: <AiOutlineGift/>
    },
    {
        id: 4,
        title: "Voucher",
        link: "/voucher",
        type: 'image',
        icon: <TiTicket/>
    },
    // {
    //     id: 5,
    //     title: "Merchant",
    //     link: "/merchant",
    //     type: 'image',
    //     icon: <BiStore/>
    // },
    {
        id: 5,
        title: "Transaksi",
        link: "/transaction/list",
        type: 'image',
        icon: <MdListAlt/>
    },
    {
        id: 6,
        title: "Profile",
        link: "/profile",
        type: 'image',
        icon: <AiOutlineUser/>
    },

    
    
]
